// react
import { useEffect } from 'react';

// context hooks
import useAsp from 'hooks/useAsp';

// types
//import { OrderType } from 'types/order';
import { useLocation } from 'react-router-dom';

const AffitownTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'affitown';
    const scriptClassName = 'affitown-load';
    const isExistScript = document.getElementById(scriptId);
    const isExistLoadScript = document.getElementsByClassName(scriptClassName);
    if (!!isExistScript) isExistScript.remove();
    if (isExistLoadScript.length) isExistLoadScript[0].remove();
    //const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? ``
      : `
      (function(){
      var uqid = "0f9D5dacD14cec65";
      var gid  = "30";
      var a=document.createElement("script");
      a.dataset.uqid=uqid;a.dataset.gid=gid;a.id="afadfpc-0f9D5dacD14cec65gid30-"+Date.now();
      a.src="//ac.affitown.jp/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);
      document.head.appendChild(a);
      })();
      `;
    document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <></>;
};

export default AffitownTag;
